// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3L-Z3","inner":"Footer_inner__3n_cG","copyright":"Footer_copyright__2vmBC"};